import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { attachmentMaster } from "src/app/Models/BasicForms/attachmentMaster";
import { commentM } from "src/app/Models/BasicForms/commentM";
import { moduleMaster } from "src/app/Models/BasicForms/moduleMaster";
import { worklogM } from "src/app/Models/BasicForms/worklogM";
import { ApiService } from "src/app/Service/api.service";
import { formatDistance } from "date-fns";
import { CookieService } from "ngx-cookie-service";
import { ModuleMappingComponent } from "../../ModuleM/module-mapping/module-mapping.component";

@Component({
  selector: "app-module-feature-view",
  templateUrl: "./module-feature-view.component.html",
  styleUrls: ["./module-feature-view.component.css"],
  providers: [DatePipe],
})
export class ModuleFeatureViewComponent implements OnInit {
  @Input() moduleData: moduleMaster;
  @Input() type: number;
  @Input() typeID: number;
  @Input() roadmaptrue: any;

  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService
  ) {}

  loggedUserID: any;

  ngOnInit(): void {
    this.loadAllProjects();
    // this.loadAllTaggedUsers();
    this.loggedUserID = this._apiService.userId;


    if(this.moduleData  && this.roadmaptrue==true){
      this.getFeatureModuleIDWise(this.moduleData.ID);

      this.getAttachmentIDWise(
        this.type,
        this.moduleData.ID
      );
      this.getCommentIDWise(
        this.type,
        this.moduleData.ID
      );
      this.getWorklogIDWise(
        this.type,
        this.moduleData.ID
      );

      if (this.moduleData["ASSIGNEE_IDS"] == null) {
        this.moduleData["ASSIGNEE_IDS"] = "0";
      }

      if (this.moduleData["REPORTER_IDS"] == null) {
        this.moduleData["REPORTER_IDS"] = "0";
      }

      this.getAssigneeFromID(
        this.moduleData["ASSIGNEE_IDS"]
      );
      this.getReporterFromID(
        this.moduleData["REPORTER_IDS"]
      );

      this.assignInputHidden = true;
    }





  }

  projectList = [];

  loadAllProjects() {
    this._apiService
      .getAllProjects(0, 0, "ID", "desc", " and IS_ACTIVE=1")
      .subscribe(
        (projectData) => {
          this.projectList = projectData["data"];
        },
        (err) => {}
      );
  }

  onAssigneeChange() {
    this.moduleData.PROJECT_ID = this.moduleData.PROJECT_ID;
    this.moduleData.NAME = this.moduleData.NAME;
    this.moduleData.DESCRIPTION = this.moduleData.DESCRIPTION;
    this.moduleData.ESTIMATED_MANDAYS = this.moduleData.ESTIMATED_MANDAYS;
    this.moduleData.START_DATE = this.moduleData.START_DATE;
    this.moduleData.END_DATE = this.moduleData.END_DATE;
    this.moduleData.STATUS = this.moduleData.STATUS;
    this.moduleData.ESTIMATED_HOURS = 0;
    this.moduleData.ESTIMATED_MINUTES = 0;
    this.moduleData.ESTIMATED_SECONDS = 0;
    this.moduleData.IS_ACTIVE = true;

    this.moduleData.ASSIGNEES = this.ASSIGNEE_ID;
    this.moduleData.REPORTER_ID = this._apiService.userId;
    this.moduleData.TYPE = 2;

    if (this.moduleData.ID) {
      this._apiService.updateModule(this.moduleData).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success("Module Updated Successfully", "");

            this.getAssigneeAfterModifyAssignees();
            this.getReporterAfterModifyAssignee();
            this.assignInputHidden = true;
            this.ASSIGNEE_ID = [];

            this.logtext =
              "Update & Close - Module Master form - SUCCESS - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext =
              "Update & Close - Module Master form - ERROR - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  onContentNameChange(moduleName) {
    this.moduleData.PROJECT_ID = this.moduleData.PROJECT_ID;
    this.moduleData.NAME = moduleName;
    this.moduleData.DESCRIPTION = this.moduleData.DESCRIPTION;
    this.moduleData.ESTIMATED_MANDAYS = this.moduleData.ESTIMATED_MANDAYS;
    this.moduleData.START_DATE = this.moduleData.START_DATE;
    this.moduleData.END_DATE = this.moduleData.END_DATE;
    this.moduleData.STATUS = this.moduleData.STATUS;
    this.moduleData.ESTIMATED_HOURS = 0;
    this.moduleData.ESTIMATED_MINUTES = 0;
    this.moduleData.ESTIMATED_SECONDS = 0;
    this.moduleData.IS_ACTIVE = true;

    if (this.moduleData.ID) {
      this._apiService.updateModule(this.moduleData).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success("Module Updated Successfully", "");
            this.logtext =
              "Update & Close - Module Master form - SUCCESS - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });

            // this.drawerClose();
          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext =
              "Update & Close - Module Master form - ERROR - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  onContentDescriptionChange(moduledescriptio) {
    this.moduleData.PROJECT_ID = this.moduleData.PROJECT_ID;
    this.moduleData.NAME = this.moduleData.NAME;
    this.moduleData.DESCRIPTION = moduledescriptio;
    this.moduleData.ESTIMATED_MANDAYS = this.moduleData.ESTIMATED_MANDAYS;
    this.moduleData.START_DATE = this.moduleData.START_DATE;
    this.moduleData.END_DATE = this.moduleData.END_DATE;
    this.moduleData.STATUS = this.moduleData.STATUS;
    this.moduleData.ESTIMATED_HOURS = 0;
    this.moduleData.ESTIMATED_MINUTES = 0;
    this.moduleData.ESTIMATED_SECONDS = 0;
    this.moduleData.IS_ACTIVE = true;

    if (this.moduleData.ID) {
      this._apiService.updateModule(this.moduleData).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success("Module Updated Successfully", "");
            this.logtext =
              "Update & Close - Module Master form - SUCCESS - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });

            // this.drawerClose();
          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext =
              "Update & Close - Module Master form - ERROR - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  onStatusChange(moduleStatus) {
    this.moduleData.PROJECT_ID = this.moduleData.PROJECT_ID;
    this.moduleData.NAME = this.moduleData.NAME;
    this.moduleData.DESCRIPTION = this.moduleData.DESCRIPTION;
    this.moduleData.ESTIMATED_MANDAYS = this.moduleData.ESTIMATED_MANDAYS;
    this.moduleData.START_DATE = this.moduleData.START_DATE;
    this.moduleData.END_DATE = this.moduleData.END_DATE;
    this.moduleData.STATUS = moduleStatus;
    this.moduleData.ESTIMATED_HOURS = 0;
    this.moduleData.ESTIMATED_MINUTES = 0;
    this.moduleData.ESTIMATED_SECONDS = 0;
    this.moduleData.IS_ACTIVE = true;

    if (this.moduleData.ID) {
      this._apiService.updateModule(this.moduleData).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success("Module Updated Successfully", "");
            this.logtext =
              "Update & Close - Module Master form - SUCCESS - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });

            // this.drawerClose();
          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext =
              "Update & Close - Module Master form - ERROR - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  onProjectChange(moduleProject) {
    this.moduleData.PROJECT_ID = moduleProject;
    this.moduleData.NAME = this.moduleData.NAME;
    this.moduleData.DESCRIPTION = this.moduleData.DESCRIPTION;
    this.moduleData.ESTIMATED_MANDAYS = this.moduleData.ESTIMATED_MANDAYS;
    this.moduleData.START_DATE = this.moduleData.START_DATE;
    this.moduleData.END_DATE = this.moduleData.END_DATE;
    this.moduleData.STATUS = this.moduleData.STATUS;
    this.moduleData.ESTIMATED_HOURS = 0;
    this.moduleData.ESTIMATED_MINUTES = 0;
    this.moduleData.ESTIMATED_SECONDS = 0;
    this.moduleData.IS_ACTIVE = true;

    if (this.moduleData.ID) {
      this._apiService.updateModule(this.moduleData).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success("Module Updated Successfully", "");
            this.logtext =
              "Update & Close - Module Master form - SUCCESS - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });

            // this.drawerClose();
          } else {
            this.notificationService.error("Failed to Update Module", "");
            this.logtext =
              "Update & Close - Module Master form - ERROR - " +
              JSON.stringify(this.moduleData) +
              " KEYWORD [C - Module Master ]";
            this._apiService
              .addLog("A", this.logtext, this._apiService.emailId)
              .subscribe((successCode) => {
                if (successCode["code"] == "200") {
                } else {
                }
              });
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  attachmentDrawerVisible = false;
  attachmentDrawerTitle = "";
  attachmentDrawerData: attachmentMaster = new attachmentMaster();
  typeForAttachmentDrawer: number;
  typeIDForAttachmentDrawer: number;

  addAttachment() {
    this.attachmentDrawerTitle = "Add Attachment";
    this.attachmentDrawerData = new attachmentMaster();
    this.attachmentDrawerVisible = true;
    this.attachmentDrawerData.IS_ACTIVE = true;

    this.attachmentDrawerData.TYPE = this.type;
    this.attachmentDrawerData.TYPE_ID = this.typeID;

    this.typeForAttachmentDrawer = this.type;
    this.typeIDForAttachmentDrawer = this.typeID;

    this.logtext = "ADD - Attachment form KEYWORD [A - Attachment] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  attachmentDrawerClose() {
    this.getAttachmentIDWise(this.type, this.typeID);
    this.attachmentDrawerVisible = false;
  }

  get callBackAttachmentDrawerClose() {
    return this.attachmentDrawerClose.bind(this);
  }

  worklogDrawerVisible = false;
  worklogDrawerTitle = "";
  worklogDrawerData: worklogM = new worklogM();
  typeForWorklogDrawer: number;
  typeIDForWorklogDrawer: number;
  logtext = "";
  estimatedMandays: any;

  addWorklog() {
    this.spinnn=true
    this.worklogDrawerTitle = "Add Worklog";
    this.worklogDrawerData = new worklogM();
    this.worklogDrawerVisible = true;
    this.worklogDrawerData.IS_ACTIVE = true;

    this.worklogDrawerData.TYPE = this.type;
    this.worklogDrawerData.TYPE_ID = this.typeID;

    this.typeForWorklogDrawer = this.type;
    this.typeIDForWorklogDrawer = this.typeID;

    this.estimatedMandays = this.moduleData.ESTIMATED_MANDAYS;

    this.logtext = "ADD - Worklog form KEYWORD [A - Worklog] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
    this.spinnn=false

        } else {
    this.spinnn=false

        }
      });
  }

  taggedUserList = [];

  loadAllTaggedUsers() {
    this._apiService.getAllUsers(0, 0, "ID", "desc", "").subscribe(
      (userData) => {
        this.taggedUserList = userData["data"];
      },
      (err) => {}
    );
  }

  COMMENT_TEXT_TO_SEND: string = "";
  TAGGED_USERS_TO_SEND: string = "";
  commentDataToSend: commentM = new commentM();
  isSendCommentButtonSpinning = false;

  sendComment() {
    var isOk = true;

    if (this.COMMENT_TEXT_TO_SEND != undefined) {
      if (this.COMMENT_TEXT_TO_SEND.trim() == "") {
        isOk = false;
        this.notificationService.error("Please Enter Valid Comment", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Comment", "");
    }

    if (this.TAGGED_USERS_TO_SEND != undefined) {
      if (this.TAGGED_USERS_TO_SEND.trim() == "") {
        isOk = false;
        this.notificationService.error("Please Select Tagged User", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select Tagged User", "");
    }

    if (isOk) {
      this.isSendCommentButtonSpinning = true;

      this.commentDataToSend.COMMENT_DATETIME = new Date();
      this.commentDataToSend.COMMENT_DATETIME =
        this.datePipe.transform(
          this.commentDataToSend.COMMENT_DATETIME,
          "yyyy-MM-dd HH:mm"
        ) + ":00";

      this.commentDataToSend.TYPE = this.type;
      this.commentDataToSend.TYPE_ID = this.typeID;
      this.commentDataToSend.TAGGED_USERS =
        this.TAGGED_USERS_TO_SEND.toString();
      this.commentDataToSend.USER_ID = this._apiService.userId;
      this.commentDataToSend.IS_ACTIVE = true;

      if (!this.commentDataToSend.ID) {
        this._apiService.createComment(this.commentDataToSend).subscribe(
          (successCode) => {
            this.isSendCommentButtonSpinning = false;

            if (successCode["code"] == "200") {
              this.notificationService.success(
                "Comment Added Successfully",
                ""
              );
            } else {
              this.notificationService.error("Failed to Add Comment", "");
            }
          },
          (err) => {
            this.isSendCommentButtonSpinning = false;

            if (err["ok"] == false) {
              this.notificationService.error("Server Not Found", "");
            }
          }
        );

        this.commentClear();
      }
    }
  }

  commentClear() {
    this.COMMENT_TEXT_TO_SEND = "";
    this.TAGGED_USERS_TO_SEND = "";
    this.commentDataToSend = new commentM();
  }

  commentData: [];
  isCommentSpinning = false;
  isLoadMoreButtonSpinning = false;
  isLoadMoreButtonHide = false;

  addMorePage = 5;
  nextPage = 1;

  loadMoreCommentIDWise() {
    this.addMorePage = this.addMorePage + 5;
    this.getCommentIDWise(
      this.type,
      this.typeID,
      this.nextPage,
      this.addMorePage
    );
  }

  getCommentIDWise(type, typeID, pageIndex: number = 1, pageSize: number = 5) {
    this.isLoadMoreButtonHide = false;

    if (pageSize == 5) {
      this.isCommentSpinning = true;
      this.addMorePage = 5;
    } else {
      this.isLoadMoreButtonSpinning = true;
    }

    let filterStr =
      " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
    this._apiService
      .getComments(pageIndex, pageSize, "COMMENT_DATETIME", "desc", filterStr)
      .subscribe(
        (data) => {
          this.isCommentSpinning = false;
          this.isLoadMoreButtonSpinning = false;
          this.commentData = data["data"];

          if (data["data"].length == data["count"]) {
            this.isLoadMoreButtonHide = true;
          }
        },
        (err) => {
          if (err["ok"] == false)
            this.notificationService.error("Server Not Found", "");
        }
      );
  }

  worklogData: [];
  allWorklogData: [];
  isWorklogSpinning = false;
  isWorklogLoadMoreButtonSpinning = false;
  isWorklogLoadMoreButtonHide = false;

  worklogAddMorePage = 5;
  worklogNextPage = 1;

  loadMoreWorklogIDWise() {
    this.worklogAddMorePage = this.worklogAddMorePage + 5;
    this.getWorklogIDWise(
      this.type,
      this.typeID,
      this.worklogNextPage,
      this.worklogAddMorePage
    );
  }

  getWorklogIDWise(type, typeID, pageIndex: number = 1, pageSize: number = 5) {
    this.isWorklogLoadMoreButtonHide = false;

    if (pageSize == 5) {
      this.isWorklogSpinning = true;
      this.worklogAddMorePage = 5;
    } else {
      this.isWorklogLoadMoreButtonSpinning = true;
    }

    let filterStr =
      " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
    this._apiService
      .getAllWorklogs(pageIndex, pageSize, "WORKED_DATETIME", "desc", filterStr)
      .subscribe(
        (data) => {
          this.isWorklogSpinning = false;
          this.isWorklogLoadMoreButtonSpinning = false;
          this.worklogData = data["data"];

          if (data["data"].length == data["count"]) {
            this.isWorklogLoadMoreButtonHide = true;
          }
        },
        (err) => {
          if (err["ok"] == false)
            this.notificationService.error("Server Not Found", "");
        }
      );

    // For Getting All Worklog
    this._apiService
      .getAllWorklogs(0, 0, "WORKED_DATETIME", "desc", filterStr)
      .subscribe(
        (data) => {
          this.allWorklogData = data["data"];

          this.calculateTrackedTime();
        },
        (err) => {}
      );
  }

  attachmentData: [];
  isAttachmentSpinning = false;

  getAttachmentIDWise(type, typeID) {
    this.isAttachmentSpinning = true;

    let filterStr =
      " and IS_ACTIVE=1 and TYPE=" + type + " and TYPE_ID=" + typeID;
    this._apiService.getAllAttachments(0, 0, "ID", "desc", filterStr).subscribe(
      (data) => {
        this.isAttachmentSpinning = false;

        this.attachmentData = data["data"];
      },
      (err) => {
        if (err["ok"] == false)
          this.notificationService.error("Server Not Found", "");
      }
    );
  }

  featureData: [];
  isFeatureSpinning = false;

  getFeatureModuleIDWise(moduleID) {
    this.isFeatureSpinning = true;

    let filterStr = " and IS_ACTIVE=1 and MODULE_ID=" + moduleID;
    this._apiService.getAllFeatures(0, 0, "ID", "desc", filterStr).subscribe(
      (data) => {
        this.isFeatureSpinning = false;

        this.featureData = data["data"];
      },
      (err) => {
        if (err["ok"] == false)
          this.notificationService.error("Server Not Found", "");
      }
    );
  }

  drawerVisible = false;
  drawerTitle = "";
  commentDrawerData: commentM = new commentM();
  typeForCommentDrawer: number;
  typeIDForCommentDrawer: number;

  add() {
    this.drawerTitle = "Add Comment";
    this.commentDrawerData = new commentM();
    this.drawerVisible = true;
    this.commentDrawerData.IS_ACTIVE = true;

    this.commentDrawerData.TYPE = this.type;
    this.commentDrawerData.TYPE_ID = this.typeID;

    this.typeForCommentDrawer = this.type;
    this.typeIDForCommentDrawer = this.typeID;

    this.logtext = "ADD - Comment Master form KEYWORD [A - Comment Master] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  drawerClose() {
    this.getCommentIDWise(this.type, this.typeID);
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  worklogDrawerClose() {
    this.getWorklogIDWise(this.type, this.typeID);
    this.worklogDrawerVisible = false;
  }

  get callBackWorklogDrawerClose() {
    return this.worklogDrawerClose.bind(this);
  }

  worklogTotalSeconds: any;
  totalWorklogTime: any;

  calculateTrackedTime() {
    this.worklogTotalSeconds = 0;
    this.totalWorklogTime = 0;

    var h = 0;
    var m = 0;
    var s = 0;

    for (var i = 0; i < this.allWorklogData.length; i++) {
      h = h + parseInt(this.allWorklogData[i]["SPENT_HOURS"]) * 3600;
      m = m + parseInt(this.allWorklogData[i]["SPENT_MINUTES"]) * 60;
      s = s + parseInt(this.allWorklogData[i]["SPENT_SECONDS"]);
    }

    this.worklogTotalSeconds = h + m + s;

    const sec = parseInt(this.worklogTotalSeconds, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = 0 + hours;
    }
    if (minutes < 10) {
      minutes = 0 + minutes;
    }
    if (seconds < 10) {
      seconds = 0 + seconds;
    }

    this.totalWorklogTime = hours + "h " + minutes + "m " + seconds + "s";
  }

  isVisible = false;
  modalName: string;
  commentText: string;
  commentDateTime: string;
  commentAuthor: string;
  isAuthorUserLoading = false;

  newTaggedUsersName = [];
  isTaggedUserLoading = false;

  showModal(comment): void {
    this.isVisible = true;
    this.modalName = "Comment Details";

    this.commentText = comment.COMMENT_TEXT;
    this.commentDateTime = comment.COMMENT_DATETIME;

    this.isAuthorUserLoading = true;
    var commentAuthorID = comment.USER_ID;
    this._apiService
      .getAllUsers(0, 0, "ID", "desc", " and ID=" + commentAuthorID)
      .subscribe(
        (userData) => {
          this.isAuthorUserLoading = false;
          this.commentAuthor = userData["data"][0]["NAME"];
        },
        (err) => {}
      );

    var taggedUsers = comment.TAGGED_USERS.split(",");
    var newTaggedUsers = [];
    for (var i = 0; i < taggedUsers.length; i++) {
      newTaggedUsers.push(parseInt(taggedUsers[i]));
    }
    //

    this.newTaggedUsersName = [];
    for (var j = 0; j < newTaggedUsers.length; j++) {
      this.isTaggedUserLoading = true;
      let userID = newTaggedUsers[j];

      this._apiService
        .getAllUsers(0, 0, "ID", "desc", " and ID=" + userID)
        .subscribe(
          (userData) => {
            //
            this.isTaggedUserLoading = false;
            this.newTaggedUsersName.push(userData["data"][0]["NAME"]);
          },
          (err) => {}
        );
    }
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  isWorklogVisible = false;
  worklogModalName: string;
  worklogDescription: string;
  worklogDateTime: string;
  worklogStartDateTime: string;
  worklogEndDateTime: string;
  worklogSpentTime: string;
  worklogAuthor: string;
  isWorklogAuthorUserLoading = false;

  showWorklogModal(worklog): void {
    this.isWorklogVisible = true;
    this.worklogModalName = "Worklog Details";

    this.worklogDescription = worklog.WORK_DESCRIPTION;
    this.worklogSpentTime =
      worklog.SPENT_HOURS +
      "h " +
      worklog.SPENT_MINUTES +
      "m " +
      worklog.SPENT_SECONDS +
      "s ";
    this.worklogDateTime = worklog.WORKED_DATETIME;
    this.worklogStartDateTime = worklog.START_DATETIME;
    this.worklogEndDateTime = worklog.END_DATETIME;

    this.isWorklogAuthorUserLoading = true;
    var worklogAuthorID = worklog.USER_ID;

    this._apiService
      .getAllUsers(0, 0, "ID", "desc", " and ID=" + worklogAuthorID)
      .subscribe(
        (userData) => {
          this.isWorklogAuthorUserLoading = false;
          this.worklogAuthor = userData["data"][0]["NAME"];
        },
        (err) => {}
      );
  }

  handleWorklogCancel(): void {
    this.isWorklogVisible = false;
  }

  edit(data: commentM) {
    this.drawerTitle = "Comment Details";
    this.commentDrawerData = Object.assign({}, data);
    this.drawerVisible = true;

    var taggedUsers = this.commentDrawerData.TAGGED_USERS.split(",");

    var newTaggedUsers = [];
    for (var i = 0; i < taggedUsers.length; i++) {
      newTaggedUsers.push(parseInt(taggedUsers[i]));
    }

    this.commentDrawerData.TAGGED_USERS = "";
    this.commentDrawerData.TAGGED_USERS = newTaggedUsers;

    this.commentDrawerData.TYPE = this.type;
    this.commentDrawerData.TYPE_ID = this.typeID;

    this.typeForCommentDrawer = this.type;
    this.typeIDForCommentDrawer = this.typeID;

    this.logtext = "EDIT - Comment Master form KEYWORD [E - Comment Master] ";

    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  editWorklog(data: worklogM) {
    this.worklogDrawerTitle = "Worklog Details";
    this.worklogDrawerData = Object.assign({}, data);
    this.worklogDrawerVisible = true;

    this.worklogDrawerData.TYPE = this.type;
    this.worklogDrawerData.TYPE_ID = this.typeID;

    this.typeForWorklogDrawer = this.type;
    this.typeIDForWorklogDrawer = this.typeID;

    this.estimatedMandays = this.moduleData.ESTIMATED_MANDAYS;

    this.logtext = "EDIT - Worklog form KEYWORD [E - Worklog] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  newAssigneesName = [];
  isAssigneeSpinning = false;

  getAssignees(AssigneeNames) {
    // this.newAssigneesName = [];
    // this.newAssigneesName = AssigneeNames.split(',');
  }

  getAssigneeFromID(assigneeID) {
    this.isAssigneeSpinning = true;

    this.newAssigneesName = [];
    var assigneeIDArr = assigneeID.split(",");

    for (var i = 0; i < assigneeIDArr.length; i++) {
      this._apiService
        .getAllUsers(0, 0, "ID", "desc", " and ID=" + assigneeIDArr[i])
        .subscribe(
          (userData) => {
            this.isAssigneeSpinning = false;
            this.newAssigneesName.push(userData["data"][0]["NAME"]);
          },
          (err) => {}
        );
    }
  }

  newReporterName = [];
  isReporterSpinning = false;

  getReporter(reporterNames) {
    // this.newReporterName= [];
    // this.newReporterName= reporterNames.split(',');
  }

  getReporterFromID(reporterID) {
    this.isReporterSpinning = true;

    this.newReporterName = [];
    var reporterIDArr = reporterID.split(",");

    for (var i = 0; i < reporterIDArr.length; i++) {
      this._apiService
        .getAllUsers(0, 0, "ID", "desc", " and ID=" + reporterIDArr[i])
        .subscribe(
          (userData) => {
            this.isReporterSpinning = false;

            this.newReporterName.push(userData["data"][0]["NAME"]);
          },
          (err) => {}
        );
    }
  }

  generateBadge(nameForBadge: string) {
    return this._apiService.createBadge(nameForBadge);
  }

  handleCancelForWorklog(): void {
    // this.notificationService.info('click cancel',"");
  }

  handleConfirmForWorklog(worklog: worklogM) {
    if (worklog.ID) {
      this._apiService.deleteWorklog(worklog.ID).subscribe(
        (successCode) => {
          if (successCode["code"] == "200") {
            this.notificationService.success(
              "Worklog Deleted Successfully",
              ""
            );
            this.getWorklogIDWise(this.type, this.typeID);
          } else {
            this.notificationService.error("Failed to Delete Worklog", "");
          }
        },
        (err) => {
          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        }
      );
    }
  }

  handleCancelForComment(): void {
    // this.notificationService.info('click cancel',"");
  }

  handleConfirmForComment(comment: commentM) {}

  getDateFormat(dateToCompare) {
    var PASSING_DATE = new Date(dateToCompare);
    var CURRENT_DATE = new Date();

    return formatDistance(CURRENT_DATE, PASSING_DATE) + " ago";
  }

  assignInputHidden: boolean;

  addAssignee() {
    // this.assigneeDrawerTitle = "Add Assignee";
    // this.assigneeDrawerData = new assigneeMapping();
    // this.assigneeDrawerVisible = true;

    // this.assigneeDrawerData.TYPE = this.type;
    // this.assigneeDrawerData.REFERENCE_ID = this.typeID;

    // this.typeForAssigneeDrawer = this.type;
    // this.typeIDForAssigneeDrawer = this.typeID;

    // this.AssigneeMappingComponentVar.loadAllAssignee();
    // this.AssigneeMappingComponentVar.getAssignee(this.type, this.typeID);

    // this.logtext = 'ADD - Assignee Mapping form KEYWORD [A - Assignee Mapping] ';
    // this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
    //   if (successCode['code'] == "200") {
    //
    //   }
    //   else {
    //
    //   }
    // });

    this.assignInputHidden = !this.assignInputHidden;

    // Check Whether Assignee(s) fills or Not.
    if (this.newAssigneeList.length == 0) {
      this.getAssigneeAfterModifyAssignees();
    }
  }

  getAssigneeAfterModifyAssignees() {
    this._apiService
      .getAllModules(0, 0, "ID", "desc", " and ID=" + this.typeID)
      .subscribe((datas) => {
        if (datas["code"] == 200) {
          this.getAssigneeFromID(datas["data"][0]["ASSIGNEE_IDS"]);
          // this.loadAllAssignee(datas['data'][0]['ASSIGNEE_IDS']);
          this.getReporterFromID(datas["data"][0]["REPORTER_IDS"]);

          this.loadAssigneeMappingWise(
            datas["data"][0]["PROJECT_ID"],
            datas["data"][0]["ASSIGNEE_IDS"]
          );
          this.loadAllRoles();
        }
      });
  }

  getReporterAfterModifyAssignee() {
    // this._apiService.getAllModules(0, 0, 'ID', 'desc', ' and ID=' + this.typeID).subscribe(datas => {
    //   if (datas['code'] == 200) {
    //
    //     this.getReporterFromID(datas['data'][0]['REPORTER_IDS']);
    //   }
    // });
  }

  getAssigneesInInput(assigneeIDS) {
    var newAssigneeArry = [];
    for (var i = 0; i < assigneeIDS.length; i++) {
      newAssigneeArry.push(Number(assigneeIDS[i]));
    }

    this.ASSIGNEE_ID = newAssigneeArry;
  }

  ASSIGNEE_ID = [];
  assigneeList = [];

  loadAllAssignee(assigneeID) {
    var USER_ID = this._apiService.userId + "," + assigneeID;

    this.assigneeList = [];

    this._apiService
      .getAllUsers(0, 0, "ID", "desc", " and ID not in (" + USER_ID + ")")
      .subscribe(
        (userData) => {
          if (userData["code"] == 200) {
            this.assigneeList = userData["data"];
          }
        },
        (err) => {}
      );
  }

  loadAssigneeMappingWise(projectID, assigneeID) {
    // var USER_ID = this._apiService.userId + ',' + assigneeID;
    var USER_ID = assigneeID;

    this.assigneeList = [];

    this._apiService
      .getAllMappedUsers(
        0,
        0,
        "ID",
        "desc",
        " and USER_ID not in (" +
          USER_ID +
          ") and IS_ACTIVE=1 and PROJECT_ID=" +
          projectID
      )
      .subscribe(
        (userData) => {
          if (userData["code"] == 200) {
            this.assigneeList = userData["data"];
          }
        },
        (err) => {}
      );
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    // level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, "ID", "desc", "").subscribe(
        (data) => {
          if (data["code"] == 200) {
            this.roleData = data["data"];
            this.findNewAssigneeList();
          }
        },
        (err) => {}
      );
    } else {
      this._apiService
        .getAllRoles(0, 0, "ID", "desc", " and LEVEL >= (" + level + ")")
        .subscribe(
          (data) => {
            if (data["code"] == 200) {
              this.roleData = data["data"];
              this.findNewAssigneeList();
            }
          },
          (err) => {}
        );
    }
  }

  newAssigneeList = [];

  findNewAssigneeList() {
    this.newAssigneeList = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (this.assigneeList[k]["ROLE_ID"] == this.roleData[j]["ID"]) {
          this.newAssigneeList.push(this.assigneeList[k]);
        }
      }
    }
  }

  mappingDrawerVisible = false;
  mappingDrawerTitle = "";
  moduleDrawerData: moduleMaster = new moduleMaster();
  moduleMappingDrawerData = [];
  @ViewChild(ModuleMappingComponent)
  ModuleMappingComponentVar: ModuleMappingComponent;

  spinnn:boolean=false
  mapModule(moduleID) {
    this.spinnn=true

    this._apiService
      .getAllModules(0, 0, "ID", "asc", " and ID=" + moduleID)
      .subscribe(
        (moduleData) => {
          if (moduleData["code"] == 200 && moduleData["data"].length > 0) {
            var existingModuleData = moduleData["data"][0];

            // Get Mapped Emp Module Wise
            this._apiService
              .getModuleDetails(existingModuleData.ID, 0)
              .subscribe(
                (data) => {
                  if (data["code"] == 200 && data["data"].length > 0) {
                    this.moduleMappingDrawerData = data["data"];

                    // Get Mapped Emp Project Wise
                    this._apiService
                      .getProjectDetails(existingModuleData.PROJECT_ID, 0)
                      .subscribe(
                        (data) => {
                          var projectMappingDrawerData = data["data"];

                          var arry = [];
                          
                          for (
                            var i = 0;
                            i < projectMappingDrawerData.length;
                            i++
                          ) {
                            if (projectMappingDrawerData[i]["IS_ACTIVE"] == 1) {
                              arry.push(projectMappingDrawerData[i]);
                            }
                          }

                          projectMappingDrawerData = arry;

                          var arry = [];
                          for (
                            var j = 0;
                            j < this.moduleMappingDrawerData.length;
                            j++
                          ) {
                            for (
                              var k = 0;
                              k < projectMappingDrawerData.length;
                              k++
                            ) {
                              if (
                                this.moduleMappingDrawerData[j]["USER_ID"] ==
                                projectMappingDrawerData[k]["USER_ID"]
                              ) {
                                this.moduleMappingDrawerData[j]["ROLE_ID"] =
                                  projectMappingDrawerData[k]["ROLE_ID"];
                                arry.push(this.moduleMappingDrawerData[j]);
                              }
                            }
                          }

                          
                          this.moduleMappingDrawerData = arry;
                          this.spinnn=false

                          
                        },
                        (err) => {}
                      );

                    this.moduleDrawerData = Object.assign(
                      {},
                      existingModuleData
                    );
                    this.mappingDrawerTitle =
                      "Team Mapping > " + existingModuleData.NAME;
                    this.mappingDrawerVisible = true;
                    this.ModuleMappingComponentVar.TASK_CATEGORY_ID = 1;
                  }
                },
                (err) => {}
              );
          }
        },
        (err) => {}
      );
  }

  mappingDrawerClose() {
    this.getAssigneeAfterModifyAssignees();
    this.getReporterAfterModifyAssignee();

    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }
}
